import api from "./api";
import { customerType } from "../components/Customers/CustomerType";
export type DeleteCostumersDto = {
  id: number | string;
};

export const getInitialPermissions = async () => {
  return await api.get("/customers/init-permissions");
};

/*Customer delete */

export const deleteCustomer = async (dto: DeleteCostumersDto) => {
  return await api.delete(`customers/${dto.id}`);
};

/*Customer By id */

export const getCustomerById = async (CustomerId: string | undefined) => {
  return await api.get(`/customers/${CustomerId}`);
};

/*search */

export const getCustomers = async (body: {
  limit: number;
  q: string;
  isActive?: boolean;
}) => {
  let url = `/customers?limit=${body.limit}&q=${body.q.toString()}`;
  if (body.isActive !== undefined) {
    url += `&isActive=${body.isActive}`;
  }
  return await api.get(url);
};

/*Customer create */

export const getCustomersDropdown = async () => {
  return await api.get(`/customers/dropdown`);
};

export const createCustomer = async (customerDetails: customerType) => {
  return await api.post("/customers", customerDetails);
};

/*Customer edit */

export const editCustomer = async (customerId: any, body: customerType) => {
  return await api.put(`/customers/${customerId}`, body);
};

/*Customer Balance */

// export const getCustomerBalance = async (customerId: any) => {
//   return await api.get(`/customers/customer-balance/${customerId}`);
// };

export const getCustomerBalance = async (
  customerId: number,
  limit: number,
  from: string,
  to: string
) => {
  return await api.get(
    `/customers/customer-balance/${customerId}?limit=${limit}&from=${from}&to=${to}`
  );
};
